<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">ETP业务系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>榜单管理</el-breadcrumb-item>
        </el-breadcrumb>

        <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top: 10px">
            <el-tab-pane label="人气榜配置" name="POPULARITY_CONFIG">
                <PopularityConfig ref="popularityConfig"/>
            </el-tab-pane>
            <el-tab-pane label="涨幅榜黑名单" name="UP_BLACK_LIST">
                <UpBlackList ref="upBlackList"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import './store';
    import api from './api';
    import PopularityConfig from './components/popularityConfig';
    import UpBlackList from './components/upBlackList';

    export default {
        name: 'Billboard',
        components: {
            PopularityConfig,
            UpBlackList
        },
        data() {
            return {
                activeName: "POPULARITY_CONFIG"
            };
        },
        methods: {
            handleClick(tab, event) {
                if (this.activeName == "POPULARITY_CONFIG") {
                    this.$refs.popularityConfig.getPopularityConfigList();
                } else if (this.activeName == "UP_BLACK_LIST") {
                    this.$refs.upBlackList.getUpBlackList();
                }
            }
        },
        created() {

        },
        mounted(){
            this.$refs.popularityConfig.getPopularityConfigList();
        }
    };
</script>

<style lang="less" scoped></style>

